import React from 'react';
import { CheckupRequestInfo } from '@companion-professional/dctypes';

import { CaptureOrUpload } from '../../../../pages/CaptureOrUpload';

import BasePage from '../../base/BasePage';

interface StdCaptureOrUploadPageProps {
  checkupRequest: CheckupRequestInfo;
  page: number;
}

// TODO: will add the page number later because typescript complains.
// Once the ui-metrics PR merged, will add relevant props to BasePage component
// to emit metrics properly to posthog.
export const StdCaptureOrUploadPage = ({ checkupRequest , page}: StdCaptureOrUploadPageProps) => {
  const pageKind = 'std_capture_or_upload';
  return (
    <BasePage
      page={page}
      pageKind={pageKind}
      checkupRequest={checkupRequest}
      renderChild={() => (
        <CaptureOrUpload checkupRequest={checkupRequest} />
      )}
    />
  )

};
